// https://oauth.vk.com/authorize?client_id=7444289&display=page&redirect_uri=https://oauth.vk.com/blank.html&scope=friends,messages,offline,video,audio,stories,messages,docs,notifications&response_type=token&v=5.126&state=123456
import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, ReplaySubject, Subject, Subscription, throttleTime, zip} from 'rxjs';
// import {tag} from "rxjs-spy/operators/tag";
import {first} from 'rxjs/operators';
import {isNull} from 'util';
import {DomSanitizer} from '@angular/platform-browser';
import {TelegramService} from '../page-telegram/telegram.service';
import {DeclinationPipe} from '../../pipes/declination.pipe';
import {environment} from '../../../environments/environment';
import {AllService} from '../../services/all.service';
import {
  Chat,
  Contact,
  IMessengerConnector,
  Message,
  MessageUser,
  Profile, ResultChatDetail, ResultHistory,
  SendMessage
} from '../../types/all.type';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {log} from '../../functions';
import {
  VkApiDocsSave,
  VkApiError,
  VkApiGetHistory,
  VkApiGetHistoryAttachments,
  VkApiGetMessagesUploadServer,
  VkApiGetProfileInfo, VkApiMessage,
  VkApiMessagesGetById
} from './vk.types';

declare let VK: any;

@Injectable({
  providedIn: 'root'
})
export class VkService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public disabledMessageTextarea = false;
  public excludeDomains = ['messenger.teleseller.ru', 'leads.teleseller.ru'];
  environment = environment;
  public loadHistoryError: boolean | any = false;
  public type = 'vk';
  public name = 'Вконтакте';
  public token: string;
  public unreadCount = 0;
  urlApi: any = 'https://messenger.soft-angel.ru:8001';
  urlApiFileUpload: any = 'https://messenger.soft-angel.ru:8001/api/file/';
  public _openChat: Chat;
  public _openChatId: any;
  public arTyping: MessageUser[] = [];
  public arProfile: Profile = {} as Profile;
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  public arHistory: Message[] = [];
  public arLocalHistory: any = {};
  public replyMessage: Message | false = false;
  public forwardMessage: Message | false = false;
  public messageLastDate: number;
  public editMessage: Message | false = false;
  public bufferMessage = '';
  public message = '';
  public isLoadedProfile = false;
  public isLoadedProfileError = false;
  public reloadRequestsSubscription: Subscription;
  arVisibleStickers: any = [];
  VK;
  public isDeleteAllMessage = false;
  apiVersion = '5.81';

  constructor(
    public notifierWrapService: NotifierWrapService,
    private declinationPipe: DeclinationPipe,
    public telegramService: TelegramService,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private allService: AllService,
    private http: HttpClient
  ) {
    const vkInit = () => {
      this.VK = VK;
      this.getToken();
      this.VK.init({
        apiId: 7444289
      });
      // this.access_token = '2b7d9c6c2cc04679ed4c131796f7874a02e1c5f9cae4dd76a771000d51aa9c1625862a6364f6c8ec8121c';
      this.VK._session = {};
      this.VK._session.sid = this.token;
    };
    try {
      vkInit();
    } catch (e) {
      console.error('VK not init');
      if (!this.VK?.api) {
        setTimeout(() => {
          vkInit();
        }, 3000);
      }
    }

    this.reloadRequestsSubscription = this.allService.wsService.reloadRequests$.subscribe((val) => {
      if (this.isLoadedProfileError) { this.loadProfile(); }
    });
    /// this.arLocalHistory = this.getVarLocal('history', {});
    // Fix
    if (this.isAuth) {
      this.loadProfile();
    }
    this.setLocalHistory$.pipe(throttleTime(3000)).subscribe((data) => {
      this.setLocalHistory(data.id, data.arHistory);
    });
  }
  get status(): boolean {
    return !this.allService._vkDisconnect;
  }
  getUploadUrl(chatId, type = 'doc'): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    return new Observable((observer) => {
      this.VK.Api.call(
        'docs.getMessagesUploadServer',
        {
          type,
          peer_id: chatId,
          v: this.apiVersion,
          lang: 'ru'
        },
        (r: { response: VkApiGetMessagesUploadServer } | VkApiError) => {
          if (r.response) {
            observer.next(
              {
                uploadUrl: 'https://messenger.soft-angel.ru/vk.upload.php?upload_url=' + encodeURIComponent(r.response.upload_url),
                method: 'post'
              }
            );
            observer.complete();
          } else {
            observer.error(r);
            observer.complete();
          }
        }
      );
    });
  }

  login(username: string, password: string) {
    const arData = {
      username,
      password
    };
    return this.http.post(`${this.environment.vk}/api/vk/auth`, arData);
  }
  addedFile(file: File): Observable<{ uploadUrl: string }> {
    return new Observable((observer) => {
      observer.next(undefined);
      observer.complete();
    });
  }
  saveFile(file: File | Blob, title = '') {
    const subject = new Subject<any>();
    this.VK.Api.call(
      'docs.save',
      {
        file: file[1].file,
        title,
        v: this.apiVersion,
        lang: 'ru'
      },
      (r) => {
        if (r.response?.length > 0) {
          const doc = r.response[0];
          subject.next({name: `doc${doc.owner_id}_${doc.id}`});
          subject.complete();
          // const audio_message = r.response[0];
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  get isAuth(): boolean {
    return !isNull(localStorage.getItem('vk_token'));
  }

  logout(onlyToken = true): void {
    console.warn('VK logout');
    localStorage.removeItem('vk_token');
  }

  getToken() {
    this.token = localStorage.getItem('vk_token');
  }

  setToken(token: string): void {
    if (token) {
      localStorage.setItem('vk_token', token);
      this.token = token;
      this.allService.setCookie('vk_token', this.token, {expires: 99999999});
      this.VK._session.sid = token;
      setTimeout(() => {
        this.allService.login$.next(this);
      }, 100);
    }
  }

  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem('vk_' + name + '_' + this.token)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  setVarLocal(name: string, val: any): void {
    localStorage.setItem('vk_' + name + '_' + this.token, JSON.stringify(val));
  }

  setLocalHistory(id, arHistory: Message[]): void {
    if (!id) { return; }
    this.arLocalHistory[id] = arHistory;
    // this.setVarLocal('history', this.arLocalHistory);
  }

  loadProfile(): Observable<Profile> {
    this.isLoadedProfileError = false;
    this.VK.Api.call('account.getProfileInfo', {
      v: this.apiVersion,
      lang: 'ru'
    }, (r: VkApiGetProfileInfo | VkApiError) => {
      if (r.response) {
        const profile: Profile = {
          ...{
            name: {
              first: r.response.first_name || '',
              last: r.response.last_name || ''
            },
            avatar: r.response.photo_200,
            avatar_orig: r.response.photo_200,
            phone_number: r.response.phone,
            username: r.response.screen_name,
            is_self: true,
          },
          ...r.response
        };
        // log('loadProfile');
        // log(profile);
        this.arProfile = profile;
        this.isLoadedProfile = true;
        this.setVarLocal('profile', this.arProfile);
        this.getProfile$.next(this.arProfile);
      } else {
        this.getProfile$.error(r);
        this.isLoadedProfileError = true;
      }
    });
    return this.getProfile$;
  }

  getProfile(initiator = ''): Observable<Profile> {
    if (this.isLoadedProfile) {
      return new Observable((observer) => {
        observer.next(this.arProfile);
        observer.complete();
      });
    } else {
      return this.getProfile$;
    }
  }

  forwardMessages(chatId: any, fromChatId: any, messages: Message[]) {
    const messageIds = messages.map((x) => x?.id || x);
    const subject = new Subject<any>();
    const data: any = {
      random_id: Math.floor(Math.random() * 99999999),
      peer_id: chatId,
      forward_messages: messageIds.join(','),
      v: '5.92',
      lang: 'ru'
    };
    this.VK.Api.call('messages.send', data, (r) => {
      if (r.response) {
        subject.next({status: 'ok'});
        subject.complete();
      } else {
        subject.error(r);
        subject.complete();
      }
    });
    return subject;
  }

  deleteMessages(chatId: any, revoke = true, messageIds: string[], force = true) {
    const subject = new Subject<any>();
    this.VK.Api.call(
      'messages.delete',
      {
        message_ids: messageIds.join(','),
        v: '5.92',
        lang: 'ru',
        delete_for_all: revoke ? 1 : 0
      },
      (r) => {
        if (r.response) {
          subject.next({});
          subject.complete();
        } else if (r.error) {
          log('deleteMessages', r);
          if (r.error.error_code === 15 && force) {
            return this.deleteMessages(chatId, !revoke, messageIds, false).subscribe(() => {
              subject.next({});
              subject.complete();
            });
          } else {
            subject.error(r);
            subject.complete();
          }
          // subject.next({error_msg: r.error.error_msg});
        }
      }
    );
    return subject;
  }

  saveMessage(arData: Message) {
    // TODO
    return this.http.put(`${this.urlApi}/api/vk/messages/`, arData);
  }

  sendMessage(arData: SendMessage): Observable<Message[]> {
    const subject = new Subject<any>();
    const data: any = {
      random_id: Math.floor(Math.random() * 99999999),
      peer_id: arData.chat_id,
      v: '5.92',
      lang: 'ru'
    };
    if (arData.text) {
      data.message = arData.text;
    }
    if (arData.attachments) {
      data.attachment = arData.attachments.join(',');
    }
    if (arData?.reply_message?.id) {
      data.reply_to = arData.reply_message?.id;
    }
    this.VK.Api.call('messages.send', data, (r) => {
      if (r.response) {
        this.VK.Api.call('messages.getById', {
          message_ids: r.response,
          extended: 1,
          v: '5.92',
          lang: 'ru'
        }, (res: { response: VkApiMessagesGetById }) => {
          if (res.response) {
            subject.next(res.response.items.map((v) => this.messageRender(v, res.response, false)));
            subject.complete();
          } else {
            subject.error(r);
            subject.complete();
          }
        });
      } else {
        subject.error(r);
        subject.complete();
      }
    });
    return subject;
  }

  sendKeyBoard(arData: any) {
    return this.http.post(`${this.urlApi}/api/vk/messages/`, arData);
  }

  mediaSearch(id, type = 'photo', limit = 15, timeout = 0) {
    const subject = new Subject<any>();
    setTimeout(() => {
      this.VK.Api.call(
        'messages.getHistoryAttachments',
        {
          peer_id: id,
          media_type: type,
          count: limit,
          v: this.apiVersion,
          lang: 'ru'
        },
        (r: VkApiGetHistoryAttachments | VkApiError) => {
          if (r.response) {
            r.response.items.forEach((v) => {
              this.attachmentRender(v.attachment, v);
            });
            subject.next(r.response.items);
            subject.complete();
          } else {
            subject.error(r);
            subject.complete();
          }
        }
      );
    }, timeout * 1000);

    return subject;
  }

  getDetailInfo(chatId: any): Observable<ResultChatDetail> {
    const subject = new Subject<any>();
    const arResult: any = {};
    let chat: any = {id: chatId};
    let user: any;
    this.getChatsByIds([chatId]).subscribe(
      (res) => {
        if (res.results?.length > 0) {
          chat = res.results[0];
          if (chat.chat_settings) {
            chat.members_count = chat.chat_settings.members_count;
          }
          if (chat.type === 'private') {
            // TODO костыль
            user = chat;
            // this.getUserFromProfiles(user, response.profiles);
          }
        }
        const httpZip = zip(
          this.mediaSearch(chatId, 'photo', 15, 0.2),
          this.mediaSearch(chatId, 'doc', 15, 0.5),
          this.mediaSearch(chatId, 'video', 15, 0.7),
          this.mediaSearch(chatId, 'link', 15, 1),
          // this.mediaSearch(chatId, 'voice_note', 15, 4),
          this.mediaSearch(chatId, 'audio', 15, 1)
        );
        httpZip.subscribe(
          (val) => {
            arResult.photo = val[0];
            arResult.document = val[1];
            arResult.video = val[2];
            arResult.url = val[3];
            // arResult['voice_note = val[4];
            arResult.audio = val[4];

            arResult.chat = chat;
            if (user) {
              arResult.user = user;
            }
            subject.next(arResult);
            subject.complete();
          },
          (error) => {
            subject.error(error);
            subject.complete();
          }
        );
      },
      (error) => {
        subject.error(error);
        subject.complete();
      }
    );
    return subject;
  }

  chatSearch(id: any, filter = '') {
    return this.http.get(`${this.urlApi}/api/vk/chats/search/${id}`);
  }

  getChatSearch(id: any, filter = 'empty', query = '', offset = 0, limit = 15) {
    return new Observable((observer) => {
      observer.next({result: []});
      observer.complete();
    }).pipe(first()); // , tag("getChatSearch")
  }

  getGlobalSearch(query = '', limit = 15) {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    }).pipe(first()); // tag("getGlobalSearch")
  }

  sendVoice(file, chatId): Observable<Message[]> {
    const subject = new Subject<any>();
    // TODO Лучше не запрашивать часто, передалать
    this.VK.Api.call(
      'docs.getMessagesUploadServer',
      {
        type: 'audio_message',
        peer_id: chatId,
        v: this.apiVersion,
        lang: 'ru'
      },
      (r: { response: VkApiGetMessagesUploadServer } | VkApiError) => {
        if (r.response) {
          const formData: FormData = new FormData();
          formData.append('file', file);
          formData.append('upload_url', r.response.upload_url);
          return this.http.post('https://messenger.soft-angel.ru/vk.upload.php', formData).subscribe((res: any) => {
            this.VK.Api.call(
              'docs.save',
              {
                file: res.file,
                title: 'Аудиозапись',
                v: this.apiVersion,
                lang: 'ru'
              },
              (r: VkApiDocsSave | VkApiError) => {
                if (r.response?.length > 0) {
                  const audioMessage = r.response[0];
                  this.sendMessage({
                    chat_id: chatId,
                    attachments: [`doc${audioMessage.owner_id}_${audioMessage.id}`]
                  }).subscribe(
                    (result: any) => {
                      subject.next(result);
                      subject.complete();
                    },
                    (error) => {
                      this.errorHandling(error);
                    }
                  );
                } else {
                  subject.error(r);
                  subject.complete();
                }
              }
            );
          });
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  getFile(fileId: string, fileUniqueId: string, ungzip = false) {
    return this.http.get(`${this.urlApi}/api/vk/file/${fileId}/?file_unique_id=${fileUniqueId}&ungzip=${ungzip}`);
  }

  loadAttachment$(attachment): Observable<any> {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    });
  }

  // TODO
  getFile$(fileId: string, fileUniqueId = '', log = ''): Observable<any> {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    }).pipe(first()); // , tag("getFile$")
  }

  getThumbSrc(attachment) {
    log('getThumbSrc');
  }

  getFileSrc(attachment: any) {
    return attachment?.file_uri;
  }

  ///
  getStickers() {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }

  getGifs() {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }

  deleteFile(uri: string) {
    // TODO Не безопасно!!!
    return this.http.delete(`${this.urlApiFileUpload}?uri=${uri}`);
  }

  setNotify(arData: any) {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }

  getNotify(peer: string | number, chat: any = {}) {
    const subject = new Subject<any>();
    // https://vk.com/dev/account.setPushSettings
    subject.complete();
    return subject;
  }

  toggleChatPine(id, pinned: boolean) {
    const subject = new Subject<any>();
    this.VK.Api.call(
      'messages.markAsImportantConversation',
      {
        peer_id: id,
        important: pinned,
        v: this.apiVersion,
        lang: 'ru'
      },
      (r) => {
        if (r.response) {
          subject.next({
            results: r.response
          });
          subject.complete();
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  readHistory(chatId, maxId: string | number): Observable<void> {
    const subject = new Subject<void>();
    this.VK.Api.call(
      'messages.markAsRead',
      {
        message_ids: this.arHistory.map((v) => v.id).join(','),
        peer_id: chatId,
        v: this.apiVersion,
        lang: 'ru'
      },
      (r) => {
        if (r.response) {
          subject.next();
          subject.complete();
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  leaveChat(chatId, del) {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }

  contactsList(q = '', online: any = '', count = 200, timeout = 90): Observable<{ results: Chat[] | Contact[] }> {
    const subject = new Subject<any>();
    this.VK.Api.call(
      'friends.search',
      {
        q,
        order: 'hints',
        count,
        fields:
          'photo_100, photo_200_orig,photo_max_orig, has_mobile, contacts, education, online, relation, last_seen, status, can_write_private_message, can_see_all_posts, can_post, universities',
        v: this.apiVersion,
        lang: 'ru'
      },
      (r) => {
        if (r.response) {
          r.response.items.forEach((v) => {
            // log('contactsList');
            // log(v);
            v.avatar = v.photo_100;
            v.avatar_orig = v.photo_max_orig;
            v.name = {first: v.first_name || '', last: v.last_name || ''};
          });
          subject.next({
            results: r.response.items
          });
          subject.complete();
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  chatsRender(items: any, response: any) {
    items.forEach((v) => {
      if (v.conversation) {
        v.permissions = {};
        if (v?.conversation?.can_write) {
          v.permissions.can_send_messages = v.permissions.can_send_media_messages = v?.conversation?.can_write?.allowed;
        }
        v.unread_messages_count = v.conversation.unreadCount;
        v.id = v.conversation.peer.id;
        v.type = v.conversation.peer.type === 'user' ? 'private' : 'chat';
        if (v.conversation?.chat_settings) {
          v.title = v.conversation.chat_settings.title;
        }
      } else {
        v.id = v.peer.id;
        v.type = v.peer.type === 'user' ? 'private' : 'group';
      }
      if (v.last_message) {
        this.messageRender(v.last_message, response);
      }
      if (v.name) {
        v.title = v.name;
      }
      if (v.id < 0 && response.groups) {
        const group = response.groups.find((p) => p.id === Math.abs(v.id));
        if (group) {
          // log('group');
          // log(group);
          v.avatar = group.photo_100;
          v.avatar_orig = group.photo_max_orig;
          v.type = group.type;
          v.title = group.name;
        }
      }
      this.getUserFromProfiles(v, response.profiles, 'id', response);
      if (v.type === 'private') {
        v.user = {};
        this.getUserFromProfiles(v.user, response.profiles, 'id', response);
      }
    });
  }

  getChatsByIds(iDs: any): any {
    return new Observable((observer) => {
      this.VK.Api.call(
        'messages.getConversationsById',
        {
          peer_ids: iDs.join(','),
          extended: 1,
          fields:
            'last_seen,first_name,last_name,deactivated,is_closed,can_access_closed,name,screen_name,is_admin,type,photo_100,photo_200_orig,photo_max_orig,counters',
          v: this.apiVersion,
          lang: 'ru'
        },
        (r) => {
          if (r.response) {
            this.chatsRender(r.response.items, r.response);
            setTimeout(() => {
              observer.next({results: r.response.items});
              observer.complete();
            }, 50);
          } else {
            observer.error(r);
            observer.complete();
          }
        }
      );
    }).pipe(first());
  }

  chatList(filterType = '', offsetDate = 0, count = 150): Observable<{ results: Chat[] }> {
    return new Observable((observer) => {
      this.VK.Api.call(
        'messages.getConversations',
        {
          count,
          extended: 1,
          fields:
            'last_seen,first_name,last_name,deactivated,is_closed,can_access_closed,name,screen_name,is_admin,type,photo_100,photo_200_orig,photo_max_orig',
          v: this.apiVersion,
          lang: 'ru'
        },
        (r) => {
          if (r.response) {
            this.chatsRender(r.response.items, r.response);
            observer.next({results: r.response.items});
            observer.complete();
          } else {
            observer.error(r);
            observer.complete();
          }
        }
      );
      /*setTimeout(() => {
                observer.next({results: []});
                observer.complete()
                console.error('VK chatList timeout');
            }, 15000);*/
    }); // , tag("chatList")
  }

  getUserFromProfiles(v, profiles, idCode = 'id', response: boolean | any = false) {
    const profile = profiles?.find((p) => p.id === v[idCode]);
    if (profile) {
      // log('getUserFromProfiles');
      // log(profile);
      v.avatar = profile.photo_100;
      v.avatar_orig = profile.photo_max_orig;

      v.last_seen = profile.last_seen;
      v.name = {
        first: profile.first_name || profile.name || '',
        last: profile.last_name || ''
      };
      v.online = (!profile.last_seen && v.type === 'private') || profile.last_seen?.time * 1000 > Date.now() - 5 * 60;
      return v;
    } else {
      if (v[idCode] < 0 && response.groups) {
        const group = response.groups.find((p) => p.id === Math.abs(v[idCode]));
        if (group) {
          // log(group);
          // log('!getUserFromProfiles group');
          // log(group);
          v.avatar = group.photo_100;
          v.avatar_orig = group.photo_max_orig;
          v.name = {first: group.name, last: ''};
        }
      }
      return {};
    }
  }

  chatNew(title = '', arUsers: any) {
    const subject = new Subject<any>();
    this.VK.Api.call(
      'messages.createChat',
      {
        user_ids: arUsers.join(','),
        title,
        v: this.apiVersion,
        lang: 'ru'
      },
      (r) => {
        if (r.response) {
          this.chatList('', 0, 1).subscribe((res: any) => {
            subject.next(res.results[0]);
            subject.complete();
          });
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  getHistory(
    chatId: string | number,
    offsetId: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    const subject = new Subject<any>();
    log('VK getHistory');
    this.VK.Api.call(
      'messages.getHistory',
      {
        offset: currentCount,
        extended: 1,
        count: limit,
        peer_id: chatId,
        fields: '',
        v: this.apiVersion,
        lang: 'ru'
      },
      (r: { response: VkApiGetHistory } | VkApiError) => {
        if (r.response) {
          // fix out_read
          if (!r.response.out_read && r.response?.conversations?.length > 0) {
            r.response.out_read = r.response?.conversations[0]?.out_read;
          }
          const messages: Message[] = [];
          for (let i = 0; i < r.response.items.length; i++) {
            // r.response.items[i].keyboard = [];
            messages[i] = this.messageRender(r.response.items[i], r.response, false);
          }
          let chat: Chat | any = {};
          this.getChatsByIds([chatId]).subscribe((res) => {
            if (res?.results?.length > 0) {
              chat = res?.results[0];
              if (chat.chat_settings) {
                chat.members_count = chat.chat_settings.members_count;
              }
            }
            subject.next({
              results: messages.reverse(),
              chat
            });
            subject.complete();
          });
        } else {
          subject.error(r);
          subject.complete();
        }
      }
    );
    return subject;
  }

  /*
   */
  messageRender(v: any, response: VkApiMessagesGetById | VkApiGetHistory, read = true): Message {
    v.keyboard = [];
    // TODO add
    delete v.keyboard;
    const symbols = {
      '<br>': '\n',
      '&_amp;': '&',
      '&_quot;': '"',
      '&_lt;': '<',
      '&_gt;': '>',
      '&_tilde;': '~',
      '&_circ;': 'ˆ',
      '&_ndash;': '–',
      '&_mdash;': '—',
      '&_euro;': '€',
      '&_permil;': '‰'
    };
    v.attachments = v?.attachments ? v?.attachments : [];
    v.text = v.body || v.text;
    if (v.text) {
      v.text = v.text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    v.text_list = v.text || '';
    if (v.fwd_messages?.length > 0) {
      v.text_list = v.fwd_messages?.length + ' сообщений';
    }
    if (v.type === 'reply' && response.profiles) {
      v.forward_from = {id: v.user_id};
      this.getUserFromProfiles(v.forward_from, response.profiles, 'id', response);
    }
    v.online = false;
    v.chat_id = v.peer_id;
    v.edit_date = v.update_time;
    v.date = v.date * 1000;
    v.time = v.date;
    v.out = this.arProfile?.id === v.from_id ? 1 : v.out;
    // log('response', v, response.out_read);
    if (v.out === 0 && !read) {
      v.read = false;
    } else {
      v.read = v.id < response.out_read || (!response.out_read && read);
    }

    v.from_user = {id: v.from_id};
    if (v.geo?.coordinates?.length > 1) {
      const coordinates = v.geo?.coordinates.split(' ');
      v.attachments.push({
        type: 'location',
        longitude: coordinates[1],
        latitude: coordinates[0],
        place: v.geo?.place,
        thumb: {
          width: 250,
          height: 250
        }
      });
    }
    v.attachments.forEach((attachment) => {
      this.attachmentRender(attachment, v, response);
    });
    if (v.reply_message) {
      v.reply_to_messages = [];
      v.reply_to_messages.push(this.messageRender(v.reply_message, response));
    }
    if (v.fwd_messages?.length > 0) {
      v.reply_to_messages = [];
      // TODO надо загрузить сообщения
      v.fwd_messages.forEach((m) => {
        // TODO создать forwad
        m.type = 'reply';
        v.reply_to_messages.push(this.messageRender(m, response));
      });
    }

    if (v.action) {
      if (v.action?.type) {
        v.action_mid = v.action?.action_mid;
        v.member_id = v.action?.member_id;
        v.action = v.action.type;
      }
      v.service = true;
      const user: any = {};
      user.id = v.member_id || v.action_mid;
      if (user.id) {
        // log('response!!!');
        // log(response);
        this.getUserFromProfiles(user, response.profiles, 'id', response);
      }
      if (v.action === 'chat_create') {
        v.service_type = 'group_chat_created';
        v.text = 'Чат создан';
        v.text_list = '<i>' + v.text + '</i>';
      }
      if (v.action === 'chat_kick_user') {
        v.service_type = 'left_chat_member';
        v.text = 'Участник удален из группы';
        v.service_users = [user];
        v.text_list = '<i>' + v.text + '</i>';
      }
      if (v.action === 'chat_photo_update') {
        v.service_type = 'new_chat_photo';
        v.text = 'Фотография чата была изменена';
        v.text_list = '<i>Фотография беседы изменена</i>';
      }
      if (v.action === 'chat_photo_remove') {
        v.service_type = 'delete_chat_photo';
        v.text = 'Фотография в чате была удалена';
        v.text_list = '<i>Фотография чата удалена</i>';
      }
      if (v.action === 'chat_title_update') {
        v.service_type = 'new_chat_title';
        v.new_chat_title = v.text;
        v.text = 'Заголовок чата был изменен на ' + v.text;
        v.text_list = '<i>Заголовок чата изменен</i>';
      }
      if (v.action === 'chat_invite_user') {
        v.service_type = 'new_chat_members';
        v.text = 'Приглашен пользователь';
        v.service_users = [user];
        v.text_list = '<i>' + v.text + '</i>';
      }
      if (v.action === 'chat_pin_message') {
        v.service_type = 'chat_pin_message';
        v.text = 'Закреплено сообщение';
        v.text_list = '<i>' + v.text + '</i>';
      }
      if (v.action === 'chat_unpin_message') {
        v.service_type = 'chat_unpin_message';
        v.text = 'Откреплено сообщение';
        v.text_list = '<i>' + v.text + '</i>';
      }
      if (v.action === 'chat_invite_user_by_link') {
        v.service_type = 'chat_invite_user_by_link';
        v.service_users = [user];
        v.text = 'Пользователь присоединился к беседе по ссылке.';
        v.text_list = '<i>Присоединился пользоатель</i>';
      }
      /*
            if v.new_chat_members:
            v.service_type = 'new_chat_members'
            v.left_chat_users'] = []
            for user_obj in v.new_chat_members
            //v.left_chat_users'].append(self.getUser(user_obj))
            v.text = 'Новые участники, которые были добавлены'
            v.text_list = '<i>, Новые участники</i>'
             */
    } else {
    }

    if (v.media_list?.length > 0) {
      const valCount = this.valCount(v.media_list);
      for (let name in valCount) {
        const count = valCount[name];
        if (count > 1) {
          switch (name) {
            case 'Фото':
              name = this.declinationPipe.transform(count, ['Фотография', 'Фотографии', 'Фотографий']);
              break;
            case 'Документ':
              name = this.declinationPipe.transform(count, ['Документ', 'Документа', 'Документов']);
              break;
            case 'Голосовое':
              name = this.declinationPipe.transform(count, ['Голосовое', 'Голосовых', 'Голосовых']);
              break;
          }
        }
        const text = name;
        if (v.text_list?.length > 0) {
          v.text_list += `<i>, ${text}</i>`;
        } else {
          v.text_list += `<i>${text}</i>`;
        }
      }
    }
    this.getUserFromProfiles(v, response.profiles, 'from_id', response);
    if (v.text_list?.length === 0 && v.attachments?.length === 0) {
      v.delete = true;
      v.empty = true;
    }

    return v;
  }

  getMediaSrc(attachment, prefix = 'photo_') {
    let thumb: any = '';
    let full: any = '';
    let small: any = '';
    if (attachment?.sizes?.length > 0) {
      attachment?.sizes.forEach((photo) => {
        photo.file_uri = photo.url;
        photo.original_width = photo.width;
        photo.original_height = photo.height;
        if (photo.width < 1000 || !thumb) {
          thumb = photo;
        }
        full = photo;
      });
    } else {
      const arSizes = Object.keys(attachment)
        .filter((v) => v.indexOf(prefix) > -1)
        .map((v) => parseInt(v.replace(/\D+/g, ''), 10))
        .sort((a, b) => a - b);
      arSizes.forEach((size) => {
        const url = attachment[prefix + size];
        if (size < 1000 || !thumb) {
          thumb = url;
        }
        if (size < 300 || !small) {
          small = url;
        }
        full = url;
      });
    }
    return {thumb, full, small};
  }

  attachmentRender(attachment, message: any = {}, response: any = {}) {
    message.media_list = message.media_list || [];
    switch (attachment.type) {
      case 'photo':
        message.media_list.push('Фото');
        const arSrc: any = this.getMediaSrc(attachment.photo);
        attachment.date = attachment.photo.date * 1000;
        if (attachment.photo.photo_604) {
          attachment.thumb = {
            file_uri: attachment.photo.photo_604,
            width: attachment.photo.width,
            height: attachment.photo.height
          };
        } else {
          if (arSrc.thumb?.file_uri) {
            attachment.thumb = arSrc.thumb;
          } else {
            attachment.thumb.file_uri = arSrc.thumb;
          }
        }

        attachment.file_uri = arSrc.full?.file_uri || arSrc.full;
        attachment.thumb.small_uri = arSrc.small?.file_uri || arSrc.small;
        delete attachment.photo;
        break;
      case 'doc':
        if (attachment?.doc?.ext === 'ogg') {
          message.media_list.push('Голосовое');
          message.voice = {
            file_uri: attachment.doc.url
          };
        } else if (attachment?.doc?.ext === 'gif' && attachment?.doc?.preview?.video) {
          message.media_list.push('GIF');
          const video = attachment?.doc?.preview?.video;
          attachment.type = 'animation';
          attachment.mime_type = 'video/mp4';
          attachment.file_uri = video?.src;
          attachment.file_size = video?.file_size;
          attachment.thumb = {
            width: video?.width,
            height: video?.height
          };
        } else {
          message.media_list.push('Документ');
          attachment.date = attachment.doc.date * 1000;
          attachment.type = 'document';
          attachment.id = attachment.doc.id;
          attachment.mime_type = attachment.doc.ext;
          attachment.file_name = attachment.doc.title;
          attachment.file_size = attachment.doc.size;
          attachment.file_uri = attachment.doc.url;
        }

        const photos = attachment?.doc?.preview?.photo;
        if (photos) {
          const photo = photos.sizes.find((v) => v.type === 'i');
          if (photo) {
            attachment.thumb = {
              file_uri: photo?.src,
              width: photo?.width,
              height: photo?.height
            };
          }
        }
        delete attachment.doc;
        break;
      case 'audio':
        message.media_list.push('Аудио');
        attachment.date = attachment.audio.date * 1000;
        attachment.file_uri = attachment.audio.url;
        attachment.title = attachment.audio.title;
        attachment.performer = attachment.audio.artist;
        attachment.is_hq = attachment.audio.is_hq;
        // log('audio', attachment);
        // delete attachment.audio;
        break;
      case 'video':
        message.media_list.push('Видео');
        attachment.date = attachment.video.date * 1000;
        attachment.type = 'video_iframe';
        attachment.comments = attachment.video.comments;
        attachment.description = attachment.video.description;
        attachment.views = attachment.video.views;
        attachment.title = attachment.video.title;
        attachment.owner_id = attachment.video.owner_id;
        attachment.id = attachment.video.id;
        attachment.access_key = attachment.video.access_key;
        // const r = this.resizeMaxWidth(attachment.video.width,  attachment.video.height);
        // attachment.thumb = attachment.video.access_key;
        const arSrcVideo = this.getMediaSrc(attachment?.video);
        attachment.thumb = {
          width: attachment.video.width || 300,
          height: attachment.video.height || 200
        };
        if (arSrcVideo.thumb?.width) {
          attachment.thumb = arSrcVideo.thumb;
        } else {
          attachment.thumb.file_uri = arSrcVideo.thumb;
        }
        attachment.thumb.cover = true || !attachment.video?.height;
        // delete attachment.video;
        break;
      case 'location':
        message.media_list.push('Геопозиция');
        break;
      case 'sticker':
        message.sticker = {};
        if (attachment?.sticker?.images?.length > 0) {
          const sticker = attachment.sticker.images.find((s) => s.width === 256);
          if (sticker) {
            message.sticker.file_uri = sticker.url;
          }
        } else {
          message.sticker.file_uri = attachment?.sticker?.photo_352 || attachment?.sticker?.photo_256;
        }
        message.text_list = 'Стикер';
        // delete attachment.sticker;
        break;
      case 'link':
        attachment.type = 'web_page';
        message.text_list = attachment.link.url;
        if (attachment?.link?.photo) {
          attachment.date = attachment.link.photo.date * 1000;
        }
        attachment.url = attachment.link.url;
        attachment.display_url = attachment.link.url;
        attachment.title = attachment.link.title;
        attachment.description = attachment.link.description || attachment.link.caption;
        attachment.description_length = attachment.link.description?.length;
        attachment.full_width = false;
        delete attachment.link;
        break;
      case 'call':
        message.text_list = message.out === 1 ? 'Исходящий звонок' : 'Входящий звонок';
        break;
      case 'gift':
        message.media_list.push('Подарок');
        message.gift = true;
        const arSrcGift: any = this.getMediaSrc(attachment.gift, 'thumb_');
        attachment.thumb = {
          file_uri: arSrcGift.full?.file_uri || arSrcGift.full,
          width: 250,
          height: 250,
          original_width: 250,
          original_height: 250
        };
        break;
      case 'audio_message':
        message.text_list = 'Голосовое';
        message.voice = {
          file_uri: attachment?.audio_message?.link_ogg
        };
        delete attachment.audio_message;
        break;
      case 'wall':
        this.wallRender(attachment?.wall, message, response);
        if (attachment?.wall?.copy_history) {
          this.wallRender(attachment.wall.copy_history[0], message, response);
        }
        break;
    }
  }

  wallRender(wall, message: Message, response: any) {
    if (wall?.from_id > 0) {
      message.media_list.push('Запись пользователя');
    } else {
      message.media_list.push('Запись сообщества');
    }
    wall = {
      ...wall,
      ...this.getUserFromProfiles({id: wall.from_id}, response.profiles, 'id', response)
    };
    /*if(attachment?.wall?.copy_history) {
          const copy_history = {...attachment?.wall.copy_history};
          delete attachment?.wall.copy_history;
          attachment.wall = copy_history;
          log(attachment.wall);
        }*/
    if (wall?.attachments) {
      wall.attachments.forEach((v) => {
        this.attachmentRender(v, message, response);
      });
    }
  }

  valCount(array: any) {
    const names = {};
    array.forEach((item) => {
      names[item] = (names[item] || 0) + 1;
    });
    return names;
  }

  resizeMaxWidth(width: number, height: number) {
    const windowWidth = document.documentElement.clientWidth || window.outerWidth;
    let max_width = windowWidth - (windowWidth > 768 && windowWidth < 1200 ? 600 : 100);
    if (max_width > 300) { max_width = 300; }
    const k = max_width / width;
    return {width: width * k, height: height * k};
  }

  getVideoSrc$(attachment) {
    return new Observable((observer) => {
      this.VK.Api.call(
        'video.get',
        {
          // owner_id: attachment.video.owner_id,
          videos: attachment.owner_id + '_' + attachment.id + '_' + attachment.access_key,
          v: this.apiVersion,
          lang: 'ru'
        },
        (r) => {
          if (r.response) {
            // attachment.player = this.sanitizer.bypassSecurityTrustResourceUrl(r.response.items[0].player);
            attachment.player = r.response.items[0].player;
            observer.next(attachment);
            observer.complete();
          }
        }
      );
    }).pipe(first()); // , tag("getVideoSrc$")
  }

  loadAudio$(attachment) {
    return new Observable((observer) => {
      observer.next(attachment);
      observer.complete();
    }).pipe(first()); // , tag("loadAudio$")
  }

  addChatUser(chat_id, user_id) {
    return new Observable((observer) => {
      this.VK.Api.call(
        'messages.addChatUser',
        {
          chat_id,
          user_id,
          visible_messages_count: 1000,
          v: this.apiVersion,
          lang: 'ru'
        },
        (r) => {
          if (r.response == 1) {
            observer.next({status: true});
            observer.complete();
          } else {
            observer.error(r);
            observer.complete();
          }
        }
      );
    });
  }

  errorHandling(error: any, isNotify = true) {
    log('errorHandling');
    log(error);
    if (isNotify) {
      this.notifierWrapService.notify('error', error?.error?.error_text || error?.error?.error_msg || error?.error_msg);
    }
  }

  set openChat(chat: Chat) {
    this._openChat = chat;
  }

  get openChat(): Chat {
    return this._openChat;
  }

  get openChatId() {
    return this._openChatId;
  }
}
